export default __webpack_public_path__ + "static/media/knight_black.d714eeb4.svg";